"use client"

import { useFrontendPreferences } from "@lib/frontend-preferences"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { User } from "@medusajs/icons"

const SignInPrompt = () => {
  const { t } = useFrontendPreferences()

  return (
    <div className="sahil-acc-card flex flex-col xsmall:flex-row xsmall:items-center justify-between gap-4 p-5">
      <div className="flex items-center gap-x-4">
        <div className="sahil-acc-stat__icon !mb-0 !rounded-full !w-11 !h-11 flex-none">
          <User />
        </div>
        <div>
          <h2 className="font-semibold">{t.cart.signInTitle}</h2>
          <p className="text-small-regular sahil-acc-muted mt-1">
            {t.cart.signInBody}
          </p>
        </div>
      </div>
      <LocalizedClientLink
        href="/account"
        className="sahil-acc-btn whitespace-nowrap"
        data-testid="sign-in-button"
      >
        {t.cart.signIn}
      </LocalizedClientLink>
    </div>
  )
}

export default SignInPrompt
